import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const requestSchema = z.object({
	encryptedJourneyId: z.string(),
	paymentProviderId: z.number(),
	paymentVendorProfileId: z.number(),
	payment: z.object({
		amountWithoutVat: z.number(),
		vatAmount: z.number(),
		discountAmount: z.number().optional(),
		basmahFees: z.number(),
		dohFees: z.number(),
		icpFees: z.number().optional(),
		currency: z.string().optional(),
		providerExtension: z
			.object({
				applePayTokenRequest: z.object({
					data: z.string(),
					header: z.object({
						ephemeralPublicKey: z.string(),
						publicKeyHash: z.string(),
						transactionId: z.string(),
					}),
					signature: z.string(),
					version: z.string(),
				}),
				transactionIdentifier: z.string().optional(),
				paymentMethod: z.object({ displayName: z.string(), network: z.string(), type: z.string() }),
			})
			.optional(),
		currencyType: z.number().optional(),
	}),
});

const responseSchema = z.object({
	encryptedJourneyId: z.string(),
	url3Ds: z.string(),
	paymentId: z.string(),
	TransactionRef: z.string(),
	Last4Digits: z.number().optional(),
	amount: z.number(),
	currency: z.string(),
});

const telrPaymentAuthorize = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Payment/v2/authorize',
		method: 'POST',
		requestSchema,
		responseSchema,
		errorCodes: ['ValidaitionError', 'InternalError', 'PaymentAuthorizationFailed'],
	});

export default telrPaymentAuthorize;

export type TelrPaymentAuthorizeRequest = z.infer<typeof requestSchema>;

export type TelrPaymentAuthorizeResponse = TypeOfAPIResponse<ReturnType<typeof telrPaymentAuthorize>>;

export type TelrPaymentAuthorizeError = TypeOfAPIError<ReturnType<typeof telrPaymentAuthorize>>;
